import type { Content } from "./en";
import { fullStack } from "@/data/aiStack";

export const pl: Content = {
  scrollLabel: "Przewiń",

  nav: {
    web3: "WEB3",
    aiTeams: "AI TEAMS",
    oneToOne: "1:1 CONSULTING",
    letsTalk: "POROZMAWIAJMY",
    en: "EN",
    pl: "PL",
  },

  // ─── Gateway (/) ────────────────────────────────────────────────────────────
  gateway: {
    meta: {
      title: "Krzysztof Ścibiorek. Web3, AI, Konsulting 1:1.",
      description:
        "Konsulting Web3 GTM, AI dla zespołów marketingowych, sesje 1:1 dla founderów i kadry zarządzającej. 10 lat w tech, 10 w Web3. 30+ projektów.",
    },
    hero: {
      eyebrow: "CHRISWORKFLOWS.COM",
      headingLine1: "Strategia, AI i Web3.",
      headingHighlight: "Audyt, warsztat AI albo 1:1.",
      headingHighlight2: "Wybierz swoją ścieżkę.",
      sub: "Trzy usługi, trzy typy klientów. Wybierz to, co pasuje do Ciebie.",
      cta: "Zobacz usługi",
      ctaSecondary: "Zobacz co robię",
      availability: "Gotowy od zaraz",
      statsPills: [
        { value: "10", suffix: " lat", label: "W TECH" },
        { value: "30", suffix: "+", label: "DOWIEZIONYCH PROJEKTÓW" },
        { value: "3", suffix: " lata", label: "AI-FIRST CODZIENNIE" },
      ],
    },
    flagship: {
      deliverables: [
        { icon: "Search", label: "GTM Roadmap" },
        { icon: "FileText", label: "Narracja marki" },
        { icon: "Coins", label: "Tokenomics Review" },
        { icon: "TrendingUp", label: "Strategia launchu" },
      ],
    },
    cards: [
      {
        badge: "Główna oferta",
        eyebrow: "WEB3 / KRYPTO",
        title: "Konsulting Web3",
        desc: "GTM, brand, tokenomics, TGE i wdrożenie AI. Dla zespołów Web3, które robią coś na serio.",
        items: [
          "Audyt brandu i narracji",
          "Strategia Go-To-Market",
          "Gotowość do TGE i listingu",
          "Audyt wdrożenia AI",
        ],
        cta: "Zobacz ofertę",
        href: "/pl/web3",
      },
      {
        badge: "B2B",
        eyebrow: "WDROŻENIE AI",
        title: "AI dla Zespołów Marketingowych",
        desc: "Wdrożenie AI do Twojego zespołu marketingowego. Pipeline, research, raporty, brand voice. Dla zespołów, które mają dość robienia ręcznie tego, co AI może za nich ogarnąć.",
        items: [
          "Automatyzacja produkcji contentu",
          "Research i analiza konkurencji",
          "Automatyzacja raportowania",
          "Spójność brand voice",
        ],
        cta: "Zobacz jak to robię",
        href: "/pl/ai-teams",
      },
      {
        badge: "50 min",
        eyebrow: "KONSULTING 1:1",
        title: "Konsulting 1:1",
        desc: "50-minutowe sesje dla founderów i kadry zarządzającej. Przedstaw swój problem. Rozwiążemy go razem.",
        items: [
          "Founderzy i CEO",
          "Kadra zarządzająca",
          "Pozycjonowanie i strategia",
          "AI w roli doradcy",
        ],
        cta: "Zarezerwuj sesję",
        href: "/pl/1-1",
      },
    ],
    about: {
      eyebrow: "O MNIE",
      heading: "10 lat w tech, 10 w Web3",
      body: "3 lata codziennej pracy AI-first. 30+ projektów w Cointelegraph Accelerator: TGE, tokenomia, listingi CEX, planowanie DEX sale, go-to-market. Z Polski, w pełni zdalnie.",
      linkedinLabel: "Zweryfikuj na LinkedIn \u2192",
      linkedinHref: "https://www.linkedin.com/in/krzysztofscibiorek",
    },
    stats: [
      { value: "10", suffix: " lat", label: "w tech" },
      { value: "30", suffix: "+", label: "dowiezionych projektów" },
      { value: "3", suffix: " lata", label: "AI-first codziennie" },
      { value: "100", suffix: "+", label: "sesji doradczych" },
    ],
    footer: {
      heading1: "Do dzieła?",
      headingHighlight: "Porozmawiajmy.",
      cta: "Rozpocznij rozmowę",
    },
  },

  // ─── AI dla Zespołów Marketingowych (/ai-teams) ──────────────────────────────
  aiTeams: {
    meta: {
      title: "AI dla Zespołów Marketingowych. Krzysztof Ścibiorek.",
      description:
        "AI w Twoim dziale marketingu. Produkcja contentu, research, raportowanie, brand voice. 10+ lat w marketingu. 30+ projektów.",
    },

    hero: {
      tagline: "AI DLA ZESPOŁÓW MARKETINGOWYCH",
      headingBefore: "Twój zespół marketingowy",
      headingBefore2: "ma talent.",
      headingHighlight: "Dodaj AI, odblokuj pełny potencjał",
      sub: "Dla zespołów marketingowych tonących w ręcznej robocie. Znajduję gdzie uciekają godziny i zastępuję je AI. Twój zespół faktycznie z niego korzysta. 30+ projektów. 10+ lat w marketingu.",
      ctaPrimary: "Umów rozmowę",
      ctaSecondary: "Zobacz co buduję",
      availability: "Gotowy od zaraz",
      statsPills: [
        { value: "60-80", suffix: "%", label: "OSZCZĘDNOŚĆ CZASU W TWORZENIU CONTENTU" },
        { value: "30", suffix: "+", label: "PROJEKTÓW" },
        { value: "3-4x", suffix: "", label: "EFEKTY. BEZ REKRUTACJI." },
      ],
      builtFor: "Stworzone dla",
      trustedBy: [
        "Zespołów marketingowych",
        "Zespołów kontentowych",
        "Startupów i scale-upów",
        "Małych i średnich firm",
        "Marketingowców pracujących solo",
        "Zespołów kreatywnych i brandowych",
        "Zespołów product marketingu",
        "Zespołów operacyjnych",
        "Founderów prowadzących marketing",
      ],
    },

    services: {
      eyebrow: "Dla Zespołów Marketingowych",
      heading: "Jak pracuję z zespołami marketingowymi",
      sub: "Znajduję gdzie uciekają godziny, a następnie buduję systemy AI, które odblokowują potencjał Waszego zespołu bez rekrutacji.",
      cards: [
        {
          title: "Audyt Procesów Marketingowych",
          desc: "Mapuję cały Wasz marketing od A do Z: content, research, social, raportowanie. Potem wskazuję dokładnie gdzie uciekają godziny i co AI może za Was zrobić.",
        },
        {
          title: "Wdrożenie AI",
          desc: "Buduję automatyzacje AI w Waszych realnych narzędziach, z Waszymi briefami, wytycznymi brandu i formatami raportów. Uczysz się dlaczego, nie tylko jak.",
        },
        {
          title: "Samodzielność Zespołu",
          desc: "Twój zespół wychodzi z warsztatów z gotowym systemem. Zero tajemnic. Jeśli ktoś czegoś zapomni, dokumentacja jest pod ręką.",
        },
      ],
      price: "Od 10 000 PLN",
      priceNote: "",
      tags: ["Zespoły marketingowe Web3", "Ops marketingowe startupów", "Agencje contentowe", "Marketing prowadzony przez foundera"],
      cta: "Zacznij od rozmowy discovery",
      noFees: "Bez ukrytych opłat. Każda ze stron może się zatrzymać lub zakończyć w dowolnym momencie.",
    },

    process: {
      eyebrow: "Proces",
      heading: "Od pierwszej rozmowy do gotowych automatyzacji AI w kilka tygodni",
      steps: [
        {
          num: "01",
          title: "Discovery Call",
          desc: "Poznaję na jakich narzędziach pracujecie i co robicie: zespół, content, raporty. 30 minut. Bez pitchowania.",
        },
        {
          num: "02",
          title: "Audyt marketingowy",
          desc: "Sprawdzam co działa, a co nie. Przedstawiam co mogę zautomatyzować.",
        },
        {
          num: "03",
          title: "Sesje warsztatowe",
          desc: "Wspólnie budujemy rozwiązania i rozwiązujemy Wasze problemy. Zespół uczestniczy, więc po warsztatach prowadzi wszystko sam.",
        },
        {
          num: "04",
          title: "Przekazanie i wsparcie",
          desc: "Wychodzisz z działającymi automatyzacjami, jasną dokumentacją i opcjonalnym wsparciem, jeśli znów będziesz mnie potrzebował.",
        },
      ],
    },

    results: {
      schematicHeader: "EFEKTY WSPÓŁPRACY",
      schematicSub: "CO DOSTAJE TWÓJ ZESPÓŁ PO WDROŻENIU",
      moduleLabels: ["", "", "", ""],
      coreIntelligence: "",
      metrics: [
        { value: "60-80%", label: "oszczędność czasu w tworzeniu contentu" },
        { value: "30+", label: "dowiezionych projektów" },
        { value: "3-4x", label: "efekty. bez rekrutacji" },
        { value: "10+ lat", label: "w marketingu" },
      ],
    },

    fit: {
      eyebrow: "Dopasowanie",
      heading: "Czy to jest dla Ciebie?",
      goodFitTitle: "Dobre dopasowanie",
      notFitTitle: "Nie dla Ciebie",
      goodFit: [
        {
          title: "Head of Marketing lub founder prowadzący marketing",
          desc: "Odpowiadasz za content, kampanie lub growth i chcesz robić więcej z tym samym zespołem.",
        },
        {
          title: "Zespół marketingowy",
          desc: "Rozumiesz swoją branżę i chcesz używać AI w realnej pracy, nie tylko testować.",
        },
        {
          title: "Zmęczony powtarzalną pracą, która pochłania czas zespołu",
          desc: "Briefy, raportowanie, research, pierwsze szkice. Robota, która nie powinna zajmować ludzi.",
        },
        {
          title: "Chcesz rozumieć automatyzacje, nie tylko je otrzymać",
          desc: "Zależy Ci na tym, żeby Twój zespół mógł samodzielnie prowadzić i rozwijać systemy.",
        },
        {
          title: "Agencja lub operacja z dużą ilością contentu",
          desc: "Dużo outputu, mały zespół, dość ręcznej roboty.",
        },
      ],
      notFit: [
        {
          title: "Szukasz gotowych szablonów",
          desc: "Rozwiązuję Twoje realne problemy. Nie daję gotowych paczek promptów. Nie tak działa nauka AI.",
        },
        {
          title: "Oczekujesz wyników bez udziału zespołu",
          desc: "Zespół musi uczestniczyć. To właśnie sprawia, że to działa.",
        },
      ],
    },

    about: {
      eyebrow: "O mnie",
      heading: "10 lat budowania, 3 lata AI-first",
      paragraphs: [
        "10 lat w krypto i Web3 jako operator: launche tokenów, strategie GTM i kampanie od fazy seed po listingi na giełdach. Jeden launch osiągnął +450% w dniu listingu z wolumenem ponad 1,4M USD w ciągu pierwszych 5 dni.",
        "W Cointelegraph Accelerator: 30+ projektów Web3 (gotowość GTM i TGE), 100+ warsztatów dla założycieli, 50+ decków inwestorskich. Skróciłem czas produkcji decków o ~70% używając automatyzacji AI bez utraty głębi strategicznej.",
        "Od 2022 pracuję w trybie AI-first. Nie jednorazowe prompty. Buduję architekturę kontekstu: trwała pamięć, pliki umiejętności, protokoły sesji. Model zajmuje się syntezą. Ja zajmuję się kierunkiem, oceną i projektowaniem frameworków.",
        "Mieszkam w Polsce i pracuję w pełni zdalnie.",
      ],
      stats: [
        { value: "10", suffix: "", label: "Lat w krypto i Web3" },
        { value: "30", suffix: "+", label: "Projektów Web3 dostarczonych" },
        { value: "100", suffix: "+", label: "Warsztatów i sesji doradczych" },
        { value: "50", suffix: "+", label: "Decków inwestorskich i launchowych" },
        { value: "3", suffix: "+", label: "Lata codziennego używania AI" },
        { value: "~70%", suffix: "", label: "Skrócenie czasu produkcji contentu" },
      ],
    },

    aboutMarketing: {
      eyebrow: "O MNIE",
      heading: "10 lat w marketingu. 3 lata z AI w każdym procesie.",
      body: [
        "Ostatnie 10 lat spędziłem wewnątrz zespołów marketingowych w firmach technologicznych. Wiem gdzie uciekają godziny, co się sypie przy skalowaniu contentu, i które narzędzia dzielą zespoły dowożące od tych, które o dowożeniu tylko wspominają.",
        "Od 3 lat AI jest w każdym procesie, który prowadzę. Nie jako dodatek, ale jako integralna część pracy. Zarówno dla siebie, jak i dla zespołów, z którymi pracuję.",
        "Z Polski, pracując w pełni zdalnie z zespołami w Europie, USA i Azji.",
      ],
      credibility: [
        {
          title: "10+ Lat w Marketingu",
          desc: "Content, brand, growth i ops w startupach technologicznych, scale-upach i agencjach. 10 lat pracy.",
        },
        {
          title: "30+ Projektów Marketingowych",
          desc: "Audytuję zespoły, projektuję automatyzacje z AI i zostawiam dokumentację, po której można pracować dalej beze mnie.",
        },
        {
          title: "AI-Native od 3 lat",
          desc: "AI jest warstwą rozumowania i silnikiem wykonawczym, nie skrótem do contentu. Myślenie pozostaje moje.",
        },
      ],
      photoName: "Krzysztof Ścibiorek",
      photoRole: "Strateg Systemów AI dla Marketingu",
      linkedinLabel: "Zweryfikuj na LinkedIn \u2192",
    },

    stack: {
      eyebrow: "NARZĘDZIA",
      heading: "Narzędzia, których używam codziennie",
      items: [...fullStack],
    },

    aiSystems: {
      eyebrow: "Jak używam AI",
      heading: "Systemy, które zbudowałem i używam codziennie",
      desc: "Nie polecam narzędzi AI. Buduję z nimi systemy, które działają. To napędza moją pracę każdego dnia i to samo wdrażam u klientów.",
      tabs: [
        {
          id: "agentic",
          short: "AI, które pamięta wszystko",
          label: "Agentic AI",
          filename: "context-architecture.yml",
          description:
            "Wielowarstwowy system AI z pamięcią trwałą, plikami umiejętności i protokołami sesji. Zaprojektowany jako infrastruktura, a nie jednorazowe prompty.",
          bullets: [
            "Kontekst przenosi się między sesjami: bez powtarzania, bez utraty postępu",
            "Pliki umiejętności kodują powtarzalne procesy (launche GTM, budowanie decków, raportowanie)",
            "Zespoły replikują tę architekturę u siebie. Nie ma w tym żadnej magii, po prostu dobrze zbudowana infrastruktura.",
          ],
        },
        {
          id: "content",
          short: "Content w minuty, nie godziny",
          label: "Content w minuty, nie godziny",
          filename: "pipeline.config",
          description:
            "Od briefu do gotowego materiału w kilka minut. Każdy etap jest zautomatyzowany, człowiek sprawdza tylko tam, gdzie to ma znaczenie.",
          bullets: [
            "Od briefu, przez research, szkic, po korektę, wszystko w jednym procesie.",
            "AI wie kim jesteś i kim chcesz być. Każdy tekst brzmi jak Ty.",
            "Produkcja contentu 80% szybsza, często lepszej jakości niż ręczna robota.",
          ],
        },
        {
          id: "journal",
          short: "Decyzje zakorzenione w kontekście",
          label: "AI jako Twój Daily Journal",
          filename: "journal-protocol.md",
          description:
            "Hej, w jakim jesteś punkcie? Czego potrzebujesz i co robisz? Aktualizuje się każdego dnia, a kontekst rośnie z czasem.",
          bullets: [
            "Wiesz co masz robić rano, aktualizujesz plany w środku dnia, wieczorem widzisz co dowiozłeś.",
            "Decyzje i wnioski zapisują się automatycznie do pamięci trwałej.",
            "W końcu wiesz dlaczego robisz to, co robisz. I potrafisz to uzasadnić.",
          ],
        },
        {
          id: "dedicated-dashboards",
          short: "Twoja stacja dowodzenia",
          label: "Dedykowane Dashboardy",
          filename: "DedicatedDashboard.md",
          description:
            "Niestandardowe dashboardy HTML budowane pod konkretne projekty. Skrojone dokładnie pod Twój workflow.",
          bullets: [
            "Lekkie, jednoplikowe interfejsy (HTML/JS) bez drogich subskrypcji SaaS.",
            "Środowisko dopasowane do konkretnego tematu i Twojego procesu.",
            "W pełni modyfikowalne. Zmieniasz kolory, dodajesz kolumny, robisz co chcesz. Nic Cię nie ogranicza.",
          ],
        },
      ],
    },

    booking: {
      eyebrow: "Rezerwacja",
      heading: "Zacznij od Discovery Call",
      discoveryNote:
        "Zarezerwuj 30-minutowy Discovery Call. Bez pitchowania. Pogadamy o Waszym marketingu i zobaczymy czy do siebie pasujemy.",
      fallback: "Coś nie działa z rezerwacją?",
      fallbackLink: "Napisz do mnie na LinkedIn →",
    },

    faq: {
      eyebrow: "Pytania",
      heading: "FAQ",
      items: [
        {
          q: "Czym to się różni od konsultanta AI, który uczy promptowania?",
          a: "Promptowanie to tylko jedna warstwa. Ja buduję architekturę pod spodem: pliki brand voice, powtarzalne procesy, ustrukturyzowane systemy, które dają ten sam efekt za każdym razem, bez przepisywania promptów od zera. Twój zespół uczy się systemu, nie trików.",
        },
        {
          q: "Jak długo trwa zanim zobaczymy wyniki?",
          a: "Większość zespołów widzi realną oszczędność czasu w ciągu pierwszych dwóch tygodni. Pełne wdrożenie w zespole marketingowym zajmuje zazwyczaj 4-6 tygodni, zależnie od skali i tempa.",
        },
        {
          q: "Czy mój zespół musi mieć doświadczenie z AI?",
          a: "Nie bardzo. Zespół bez żadnego doświadczenia z AI jest często łatwiejszy niż taki, który nasiąknął już połowicznymi nawykami. Zaczynamy od zera, a po warsztatach Twój zespół prowadzi systemy samodzielnie.",
        },
      ],
      panelEyebrow: "WCIĄŻ SIĘ ZASTANAWIASZ?",
      panelHeading: "Zobaczmy razem gdzie AI ma sens u Ciebie.",
      panelBody: "30-minutowy Discovery Call. Przeglądam Twój obecny marketing i wskazuję gdzie AI naprawdę ma sens. Bez pitchowania.",
      panelCta: "Zarezerwuj Discovery Call",
    },

    footer: {
      heading1: "Twój zespół marketingowy traci dziesiątki godzin tygodniowo.",
      headingHighlight: "Naprawmy to.",
      cta: "Porozmawiajmy",
    },

    advisoryTeaser: {
      eyebrow: "Dla Indywidualnych Liderów",
      heading: "Pracujesz solo lub potrzebujesz strategicznego wsparcia?",
      body: "50-minutowe sesje dla founderów i kadry zarządzającej. Przedstaw swój problem. Rozwiążemy go razem.",
      ctaLabel: "Zobacz sesje doradcze",
      meta: "500 PLN / sesja · Zazwyczaj w tym samym tygodniu",
    },
  },

  // ─── Konsulting Web3 / Krypto (/web3) ─────────────────────────────────
  web3audit: {
    meta: {
      title: "Konsulting Web3 GTM. Krzysztof Ścibiorek.",
      description:
        "Pełny obraz: brand, GTM, tokenomics, wdrożenie AI. 10 lat w Web3. 30+ projektów w Cointelegraph Accelerator.",
    },
    hero: {
      eyebrow: "KONSULTING WEB3 / KRYPTO",
      availability: "Gotowy od zaraz",
      headingLine1: "Twój projekt ma",
      headingLine2: "luki",
      headingHighlight: "które spowalniają",
      headingHighlight2: "Twój launch.",
      sub: "Pełny obraz: Brand, GTM, Tokenomics, wdrożenie AI. Framework sprawdzony na 30+ projektach w Cointelegraph Accelerator.",
      meta: "Wycena projektowa · Od 10 000 PLN",
      ctaPrimary: "Zarezerwuj Discovery Call",
      ctaSecondary: "Co obejmuje audyt",
      statsPills: [
        { value: "10", suffix: " lat", label: "W WEB3" },
        { value: "30", suffix: "+", label: "PROJEKTÓW\nDOWIEZIONYCH" },
        { value: "6", suffix: "", label: "FILARÓW AUDYTU" },
      ],
    },
    whatIAudit: {
      eyebrow: "Zakres",
      heading: "Co obejmuje audyt",
      headingPrefix: "Co obejmuje ",
      headingGradient: "audyt",
      headingSuffix: "",
      items: [
        {
          title: "Brand i Narracja",
          desc: "Czy mówisz do swoich inwestorów i użytkowników ich językiem? Czy Twoja historia jest jasna i spójna? Sprawdzam stronę, whitepaper, sociale i pitch deck.",
        },
        {
          title: "Strategia Go-To-Market",
          desc: "Czy macie konkretne KPI? Plan na 30 i 90 dni? Co robicie przed listingiem, co po? Do kogo naprawdę mówicie i jak?",
        },
        {
          title: "Tokenomia i Listing",
          desc: "Czy tokenomia jest dobrze zaprojektowana? Rozmawialiście już z giełdami? Z jakimi? Czy selling pressure jest rozłożony? Czy vesting jest wystarczająco długi?",
        },
        {
          title: "Społeczność i Content",
          desc: "Czy macie strategię contentową, czy postujecie żeby postować? Czy kalendarz wspiera narrację, czy ją rozmywa?",
        },
        {
          title: "Wdrożenie AI",
          desc: "Czujesz, że jesteś z tyłu z AI? Mapuję bieżące użycie i wskazuję od czego zacząć.",
        },
        {
          title: "Workflow i Proces",
          desc: "Gdzie są bottlenecki spowalniające Twój zespół? Powiem Wam na co marnujecie czas i jak robić to lepiej.",
        },
      ],
    },
    whoFor: {
      eyebrow: "DLA KOGO",
      heading: "Dla founderów, którzy chcą szerszej perspektywy",
      items: [
        {
          title: "Founderzy przed TGE",
          desc: "Dla founderów, którzy potrzebują spojrzenia z zewnątrz.",
        },
        {
          title: "Zespoły po launchu",
          desc: "Dla zespołów, które wiedzą że coś nie działa, ale nie mogą wskazać co.",
        },
        {
          title: "Mocny produkt, słaby GTM",
          desc: "Dla mocnych projektów, którym brakuje strategii i pozycjonowania.",
        },
      ],
    },
    whatYouGet: {
      eyebrow: "CO DOSTAJESZ",
      heading: "Co realnie dostajesz",
      sub: "ZAWSZE KONKRET.",
      items: [
        {
          title: "Kompletny Raport",
          desc: "Diagnostyka Twojego obecnego GTM, brandu i działań. Napisana tak, abyś Ty i Twój zespół mogli od razu działać, bez setek stron do przeczytania.",
        },
        {
          title: "Priorytetowa Roadmapa",
          desc: "Plan działania na 60 dni. Twój zespół zaczyna następnego dnia. Priorytety najpierw. Nice to have na końcu.",
        },
        {
          title: "Debrief",
          desc: "Rozmowa z Twoimi founderami i leadami. Przechodzimy przez każdy wniosek i odpowiadam na pytanie 'to jak to faktycznie zrobić?'",
        },
        {
          title: "Szczera odpowiedź",
          desc: "Powiem ci wprost jeśli tech jest słaby albo rynek nie chce Twojego produktu. Bez owijania w bawełnę.",
        },
      ],
    },
    process: {
      eyebrow: "",
      heading: "Proces",
      steps: [
        {
          label: "Research",
          body: "Przed rozmową robię szybką analizę: Twoja strona, strona tokena, Twitter/X, LinkedIn, content, społeczność.",
        },
        {
          label: "Discovery Call",
          body: "30 minut. Powiesz mi gdzie jesteś, czego potrzebujesz, i co już wiesz. Słucham więcej niż mówię.",
        },
        {
          label: "Deep Dive",
          body: "60 minut z Tobą lub Twoim zespołem. Gadamy o konkretach: co działa, co się sypie, o czym nikt głośno nie mówi. Poznajemy się.",
        },
        {
          label: "Raport i Debrief",
          body: "3-5 dni na spisanie wniosków: analiza luk i roadmapa. Potem debrief. Będziesz wiedział dokładnie co masz robić i dlaczego.",
        },
      ],
    },
    whyMe: {
      eyebrow: "O MNIE",
      heading: "Dlaczego warto ze mną pracować",
      credibility: [
        {
          title: "10 Lat w Krypto",
          desc: "10 lat cykli rynkowych, zmian narracji i patrzenia na to co faktycznie działa. Nie konsultant, który poznał Web3 rok temu.",
        },
        {
          title: "30+ Dowiezionych Projektów",
          desc: "W Cointelegraph Accelerator i poprzez niezależny konsulting. TGE, listingi, GTM. Wszystko dowiezione.",
        },
        {
          title: "Specjalista GTM",
          desc: "Wiem co działa, a co nie: w DeFi, GameFi, L1/L2 i RWA.",
        },
      ],
      closer:
        "Web3 to całe moje życie. To jedyna branża, w której pracowałem.\n10 lat od środka, nie z boku.",
      photoName: "Krzysztof Ścibiorek",
      photoRole: "Strateg GTM Web3",
      linkedinVerifyLabel: "Zweryfikuj na LinkedIn →",
    },
    notFit: {
      eyebrow: "Dopasowanie",
      heading: "Kiedy to nie jest dopasowanie",
      items: [
        "Czysto spekulacyjne projekty lub memecoiny bez realnej substancji produktowej",
        "Zespoły bez decydenta dostępnego do dostarczenia kontekstu podczas deep dive",
        "Projekty bez pilności wdrożenia wniosków. Roadmapa jest tyle warta, ile z niej zrobisz",
      ],
    },
    pricing: {
      eyebrow: "Wycena",
      heading: "Wycenimy to razem",
      body: "Każdy projekt jest inny. Zakres, głębokość i deliverables audytu zależą od złożoności projektu i tego czego najbardziej potrzebujesz. Od 10 000 PLN. Zarezerwuj rozmowę discovery. Bez zobowiązań.",
    },
    book: {
      eyebrow: "Rezerwacja",
      heading: "Zacznij od rozmowy discovery",
      discoveryNote:
        "Zarezerwuj 30-minutową rozmowę discovery. Bez pitchowania. Przechodzimy przez Twój projekt i sprawdzamy czy jest wyraźne dopasowanie.",
      fallback: "Coś nie działa z rezerwacją?",
      fallbackLink: "Napisz do mnie na LinkedIn →",
    },
    scope: {
      eyebrow: "ZACZNIJMY",
      heading: "Wycenimy to razem",
      rows: [
        { label: "Pełny Audyt GTM Web3", value: "Od 10 000 PLN" },
        { label: "Architektura GTM i Roadmapa", value: "W cenie" },
        { label: "Stress Test Tokenomii", value: "Opcjonalnie" },
        { label: "Ciągła współpraca (Miesięczna)", value: "Wycena indywidualna" },
      ],
      footnote: "Jeśli zakres wykracza poza standardowy audyt, napisz. Ustalimy wycenę projektową.",
      bookCardTitle: "Zarezerwuj Discovery Call",
      bookCardDesc: "30 minut. Pogadamy o Twoim projekcie i zobaczymy czy do siebie pasujemy.",
      bookCardCta: "Otwórz Kalendarz",
      fallback: "Coś nie działa z rezerwacją?",
      fallbackLink: "Napisz do mnie na LinkedIn →",
    },
    builtFor: {
      eyebrow: "Z KIM PRACUJĘ",
      heading: "Z kim pracuję",
      items: [
        "Founderzy Web3 przed TGE",
        "Protokoły DeFi",
        "Ekosystemy L1/L2",
        "Agencje marketingowe Web3",
        "Fundusze VC",
        "RWA",
        "Projekty AI x Crypto",
      ],
    },
    faq: {
      eyebrow: "Pytania",
      heading: "FAQ",
      items: [
        {
          q: "Jak długo trwa cały proces?",
          a: "Zazwyczaj 2-3 tygodnie. Długość zależy od skali współpracy i tego, jak szybko znajdziesz czas na Deep Dive.",
        },
        {
          q: "Czy to tylko dla projektów przed launchem?",
          a: "Nie. Audyty po launchu są często najbardziej użyteczne. Masz realnych użytkowników, realne dane i realny feedback. Pre-launch dobrze ustawia fundamenty; po launchu łapię to, co faktycznie się sypie.",
        },
        {
          q: "Co dokładnie dostajesz?",
          a: "Spisaną analizę luk według obszarów, priorytetową listę działań z uzasadnieniem każdego punktu, i debrief na żywo, gdzie razem przechodzimy przez wszystko.",
        },
        {
          q: "Mój projekt jest na konkretnym chainie. Masz tam doświadczenie?",
          a: "Metodologia działa niezależnie od chaina. Zasady GTM, brandu i tokenomics nie zmieniają się w zależności od chaina. Przez 30+ projektów pracowałem z większością głównych.",
        },
      ],
      panelEyebrow: "MASZ JESZCZE PYTANIA?",
      panelHeading: "Porozmawiajmy o tym.",
      panelBody: "30-minutowy Discovery Call. Bez pitchowania. Pomogę Ci określić problem, nawet jeśli nie zaczniemy współpracy.",
      panelCta: "Zarezerwuj Discovery Call",
    },
    footer: {
      heading1: "Twój projekt zasługuje na zewnętrzne spojrzenie.",
      headingHighlight: "Znajdźmy to, co brakuje.",
      cta: "Zarezerwuj rozmowę discovery",
    },
  },

  // ─── Konsulting 1:1 (/1-1) ─────────────────────────────────────────────────
  oneToOne: {
    meta: {
      title: "Konsulting 1:1. Krzysztof Ścibiorek.",
      description:
        "50-minutowe sesje 1:1 dla founderów i kadry zarządzającej. Przynieś jedną realną decyzję. Wyjdziesz z konkretną rekomendacją popartą 10 latami w Web3 i GTM, oraz 3 latami codziennej pracy z AI.",
    },
    hero: {
      eyebrow: "1:1 KONSULTING",
      headingBefore: "Jasność dla founderów",
      headingHighlight: "i kadry zarządzającej.",
      sub: "50 minut. Ty przynosisz swój problem. Ja wnoszę 10 lat w Web3 i GTM, plus 3 lata pracy z AI na co dzień. Przechodzimy przez to razem. Wychodzisz wiedząc, co dalej.",
      meta: "50-minutowa sesja",
      ctaPrimary: "Zarezerwuj sesję",
      ctaSecondary: "Zobacz jak pracuję",
      availability: "Dostępny teraz",
      photoStatsBadge: {
        value: "10 Lat",
        label: "DOŚWIADCZENIA",
      },
    },
    supportingLineParts: [
      { text: "Twoja ", highlight: false },
      { text: "decyzja", highlight: true },
      { text: ", Twój ", highlight: false },
      { text: "kontekst", highlight: true },
      { text: ", Twój ", highlight: false },
      { text: "następny krok", highlight: true },
      { text: ".", highlight: false },
    ] as { text: string; highlight: boolean }[],
    triptych: [
      {
        label: "Twoja decyzja",
        desc: "Rozwiązujemy realny problem. Prowadziłem warsztaty, szkolenia i sesje strategiczne w 30+ projektach. Widziałem co działa, a co nie.",
        bottomLabel: "01 REALNE WYZWANIE",
      },
      {
        label: "Twój kontekst",
        desc: "Czytam Twój kontekst przed sesją. Całe 50 minut przeznaczamy na Twój problem, nie na wprowadzenie.",
        bottomLabel: "02 PRZYGOTOWANIE",
      },
      {
        label: "Twój następny krok",
        desc: "Wychodzisz z jedną konkretną rekomendacją. Nie z listą opcji.",
        bottomLabel: "03 KIERUNEK",
      },
    ],
    whoFor: {
      eyebrow: "DLA KOGO",
      heading: "Dla liderów z realnymi decyzjami do podjęcia",
      items: [
        {
          title: "Founderzy potrzebujący świeżego spojrzenia",
          desc: "Perspektywa z zewnątrz na to, czego nie widać ze środka własnego zespołu.",
        },
        {
          title: "Liderzy przed trudną decyzją",
          desc: "Pivot, launch, rekrutacja, restrukturyzacja. Chcesz to przetestować zanim się zobowiążesz.",
        },
        {
          title: "Zespoły wdrażające AI",
          desc: "Chcesz AI wplecione w Twoją realną pracę. Pokazuję jak to zrobić, na twoim konkretnym problemie.",
        },
      ],
      closer: "",
    },
    workOn: {
      eyebrow: "TEMATY SESJI",
      heading: "Nad czym możemy pracować razem",
      items: [
        "Strategia GTM i sekwencjonowanie launchu",
        "Pozycjonowanie marki i narracja",
        "AI wplecione w pracę twoją i twojego zespołu",
        "Projekt zespołu: kogo zatrudnić, kiedy i po co",
        "Rewizja pitch decka lub inwestor story",
        "Przygotowanie do ważnej rozmowy z boardem, inwestorem, zespołem",
      ],
      closer: "Możemy pogadać o jednym realnym wyzwaniu albo omówić kilka. Ty decydujesz.",
    },
    howItWorks: {
      eyebrow: "",
      heading: "Sesja",
      steps: [
        {
          label: "Discovery Call",
          body: "Zarezerwuj 30-minutowe Discovery Call. Bez pitchu, bez zobowiązań. Sprawdzamy czy masz problem wart pełnej sesji.",
        },
        {
          label: "Przed sesją",
          body: "Po rezerwacji prześlij mi krótką notatkę: nad czym pracujesz i jaki kontekst powinienem znać. Im konkretniej, tym lepsza sesja.",
        },
        {
          label: "Podczas sesji",
          body: "Rozkładamy Twoją sytuację na czynniki pierwsze. Mówię Ci co ja bym zrobił i dlaczego. Jeśli w Twoim problemie pomaga AI, pokazuję jak go użyć na Twoim realnym przypadku.",
        },
        {
          label: "Po sesji",
          body: "Wychodzisz z jasnym kierunkiem, konkretną rekomendacją i jej uzasadnieniem. Wszystko spisane.",
        },
      ],
    },
    expectations: {
      eyebrow: "Rezultaty",
      heading: "Czego możesz się spodziewać",
      items: [
        "Konkretna rekomendacja co robić dalej.",
        "Szczery feedback, taki jakiego znajomy raczej by Ci nie dał.",
        "Rozpoznaje wzorzec i możliwy łańcuch przyczynowo-skutkowy.",
        "Realny plan działania. Nie tylko poklepanie po plecach.",
      ],
    },
    whyMe: {
      eyebrow: "O MNIE",
      heading: "Dlaczego warto ze mną pracować",
      credibility: [
        {
          title: "10 Lat w Web3 i Krypto",
          desc: "Robiłem TGE, listingi, GTM i tokenomię w 30+ projektach. Analizowałem problem od środka, nie z zewnątrz.",
        },
        {
          title: "30+ Projektów na Różnych Etapach",
          desc: "TGE, listingi CEX/DEX, strategia GTM, tokenomics, budowanie zespołu. Od pre-seed do pre-Series A.",
        },
        {
          title: "3 Lata AI-Native",
          desc: "Pracuję AI-first każdego dnia. Na sesji pokazuję jak wpleść AI w Twoją realną pracę. Na żywo, na Twoim konkretnym problemie.",
        },
      ],
      closer: "Większość konsultantów da Ci framework. Ja daję ci rozwiązanie Twojego problemu.",
      photoName: "Krzysztof Ścibiorek",
      photoRole: "Konsulting 1:1",
      linkedinVerifyLabel: "Zweryfikuj na LinkedIn →",
    },
    fit: {
      eyebrow: "DOPASOWANIE",
      heading: "Czy to dobre dopasowanie?",
      goodFitLabel: "Dobre dopasowanie",
      goodFit: [
        "Jesteś founderem, CEO albo osobą decyzyjną z ważną decyzją do podjęcia",
        "Cenisz bezpośredni input i radzisz sobie ze szczerym feedbackiem",
        "Chcesz pogadać z kimś z doświadczeniem, nie posłuchać teorii z książki",
        "Jesteś otwarty na zakwestionowanie Twojego obecnego kierunku",
      ],
      lessFitLabel: "Nie dla Ciebie",
      lessFit: [
        "Szukasz ogólnych rekomendacji narzędzi AI lub przeglądu.",
        "Chcesz, żeby ktoś podjął decyzję za Ciebie.",
      ],
    },
    book: {
      eyebrow: "Rezerwacja",
      heading: "Zarezerwuj sesję",
      formatItems: ["50-minutowa sesja 1:1", "Spotkanie online"],
      price: "500 PLN",
      priceNote: "za sesję",
      payNote: "",
      discoveryNote:
        "Zacznij od 30-minutowego Discovery Call. Bez zobowiązań. Sprawdzimy czy nadajemy na tych samych falach.",
      fallback: "Coś nie działa z rezerwacją?",
      fallbackLink: "Napisz do mnie na LinkedIn →",
    },
    tools: {
      eyebrow: "Jak pracuję",
      heading: "AI na Twoim problemie",
      desc: "To nie jest tylko strategia. Pokazuję Ci jak używać AI w Twojej własnej pracy, na Twoim realnym problemie, nie ogólnym przykładzie. Wychodzisz wiedząc co uruchomić jutro.",
    },
    faq: {
      eyebrow: "Pytania",
      heading: "Najczęściej zadawane",
      items: [
        {
          q: "Co powinienem przygotować na sesję?",
          a: "Realną decyzję lub wyzwanie, przed którym stoisz. Im bardziej konkretnie, tym bardziej użytecznie. Prześlij kontekst wcześniej, żebyśmy mogli wykorzystać pełne 50 minut na substancję.",
        },
        {
          q: "Czy to przydatne dla founderów Web3 konkretnie?",
          a: "Tak. 10 lat w krypto oznacza że znam wzorce: porażki TGE, błędy GTM, luki narracyjne, pułapki tokenomii. Jeśli budujesz w Web3, to doświadczenie jest bezpośrednio istotne.",
        },
        {
          q: "Czy możemy omówić więcej niż jeden temat?",
          a: "Jedno główne wyzwanie na sesję działa najlepiej. Głębokie pójście w jedną decyzję jest bardziej użyteczne niż powierzchowne w trzech. Wiele sesji jest dostępnych jeśli potrzeba.",
        },
        {
          q: "Czym to się różni od sesji coachingowej?",
          a: "Coaching ułatwia Twoje myślenie. Ta sesja daje Ci bezpośrednią rekomendację od kogoś z odpowiednim doświadczeniem. Powiem Ci co bym zrobił i dlaczego. Ty decydujesz co z tym zrobić.",
        },
        {
          q: "Czy muszę przyjść z w pełni zdefiniowanym problemem?",
          a: "Nie. 'Wiem że coś nie działa, ale nie mogę wskazać co' to ważny punkt startowy. Część tego co robimy to identyfikacja prawdziwego pytania zanim na nie odpowiemy.",
        },
      ],
    },
    footer: {
      heading1: "Gotowy, to przemyśleć?",
      headingHighlight: "Umów spotkanie.",
      cta: "Umów spotkanie",
    },
  },

  // ─── Wspólny formularz kontaktowy ────────────────────────────────────────────
  contactForm: {
    heading: "Masz pytanie? Zadaj je bezpośrednio.",
    subheading: "Dla spraw, które nie wymagają jeszcze rozmowy. Odpisuję w 24h.",
    toggleLabel: "Masz pytanie? Napisz je tutaj",
    fields: {
      name: {
        label: "Imię",
        placeholder: "Alex",
      },
      email: {
        label: "Email",
        placeholder: "ty@firma.com",
      },
      company: {
        label: "Firma lub projekt",
        placeholder: "Opcjonalnie",
      },
      question: {
        label: "Twoje pytanie",
        placeholder: "Pytaj o co chcesz.",
        maxLength: 500,
      },
    },
    submit: "Wyślij",
    sending: "Wysyłam...",
    success: "Dostałem. Odpiszę w 24h.",
    error: "Coś poszło nie tak. Napisz do mnie na LinkedIn.",
  },

  // ─── Hire (/hire) ──────────────────────────────────────────────────────────
  hire: {
    meta: {
      title: "Krzysztof Ścibiorek. AI-Native GTM and Growth Strategist.",
      description: "10 lat w tech, 10 w Web3 i krypto. 30+ projektów od akceleratora do listingu. Dostępny teraz na senior role zdalne.",
    },
    hero: {
      availability: "Dostępny teraz",
      name: "KRZYSZTOF ŚCIBIOREK",
      subtitle: "AI-Native GTM and Growth Strategist",
      body: "Nie tylko wdrażam strategię. Buduję systemy, które sprawiają, że strategia się broni. 10 lat w tech. 10 w Web3 i krypto od strony wykonania. AI jako warstwa operacyjna, nie narzędzie.",
      roleBadges: [
        "GTM STRATEGY",
        "AI WORKFLOWS",
        "GROWTH SYSTEMS",
      ],
      statBadgeLeft: {
        value: "10 Lat",
        label: "W TECH/WEB3/CRYPTO",
      },
      statBadgeRight: {
        value: "30+",
        label: "DOWIEZIONYCH PROJEKTÓW",
      },
      bottomBar: {
        item1: "10 Lat w Tech \u00b7 3 lata AI-first",
        item2: "Dostępny Teraz \u00b7 Full-time",
        item3: "Polska \u00b7 Zdalnie \u00b7 Dostępny teraz",
        cta: "Napisz do mnie",
      },
    },
    tldr: {
      heading: "TL;DR dla Rekruterów",
      items: [
        { title: "10 Lat w Tech", desc: "10 z nich w Web3 i krypto. Operator, nie konsultant, który poznał branżę rok temu." },
        { title: "30+ Projektów", desc: "Od pre-TGE do post-listingu. Cointelegraph Accelerator i bezpośrednie mandaty." },
        { title: "Operator AI-Native", desc: "3 lata budowania workflow AI w każdym projekcie. Nie prompt engineering. Projektowanie systemów." },
        { title: "Dostępny, Zdalnie", desc: "Polska, w pełni zdalnie, otwarty na senior role w EU, US i APAC." },
        { title: "2-3 Role Równolegle", desc: "Fractional i full-time. Egzekuję w tempie małego zespołu." },
        { title: "Szybko, Automatyzuję", desc: "Każde zaangażowanie zostawia artefakty automatyzacji, które Twój zespół zachowuje i prowadzi sam." },
      ],
    },
    operatingModel: {
      eyebrow: "JAK PRACUJĘ",
      heading: "Jak pracuję",
      principles: [
        { title: "AI-First", desc: "Każdy problem zaczynam od AI. Dobry prompt + dobry kontekst = odpowiedź na prawie wszystko." },
        { title: "Systemy, nie jednorazówki", desc: "Buduję systemy, nie jednorazowe rozwiązania. To co raz zrobię, działa dalej." },
        { title: "Wysoka Sprawczość", desc: "Odpowiedzialność ponad delegowanie. Rozwiązuję problem, nie przekierowuję." },
        { title: "Gotowy na chaos", desc: "Startuję z niejasnych briefów i brudnego kontekstu. Wychodzi z tego plan i wykonanie." },
        { title: "Myślenie jest moje", desc: "AI robi syntezę. Kierunek wyznaczam ja." },
        { title: "Orientacja na Wyniki", desc: "Mierzę wyniki, nie aktywność." },
      ],
    },
    whatIDeliver: {
      eyebrow: "CO DOSTARCZAM",
      heading: "Co dostarczam",
      metrics: [
        { value: "30+", title: "Systemy Go-to-Market", desc: "Zaprojektowane od zera dla topowych protokołów Web3." },
        { value: "~70%", title: "Wzrost Efektywności", desc: "Dzięki produkcji contentu i automatyzacji napędzanej przez AI." },
        { value: "100%", title: "Dowiezione do listingu", desc: "Każdy launch tokena, który prowadziłem, trafił na giełdę zgodnie z planem." },
      ],
    },
    professionalOdyssey: {
      eyebrow: "DOŚWIADCZENIE",
      heading: "Doświadczenie",
      items: [
        { dateRange: "Wrz 2024 - Mar 2026", role: "Cointelegraph Accelerator", desc: "GTM & Growth Marketing Lead. Prowadziłem GTM dla 30+ projektów Web3, dostarczyłem 100+ warsztatów dla founderów." },
        { dateRange: "Sty 2024 - Wrz 2024", role: "Pixel Trapps", desc: "Token Launch & GTM Lead. +450% w dniu listingu i $1.4M+ wolumenu w pierwszych 5 dniach." },
        { dateRange: "Kwi 2023 - Gru 2023", role: "Empeiria", desc: "Founding Growth Marketing Lead. Zbudowałem go-to-market od zera." },
        { dateRange: "Sty 2023 - Kwi 2023", role: "3X Capital", desc: "Investment Analyst. Oceniałem crypto-native founderów i wczesne tezy inwestycyjne." },
        { dateRange: "Mar 2022 - Gru 2022", role: "Norion", desc: "Tokenomics Specialist. Przygotowywałem tokenomię i projektowałem systemy incentive." },
        { dateRange: "Kwi 2020 - Lut 2022", role: "CloudBest", desc: "Blockchain & Crypto Manager. Widziałem jak firma rośnie z 20 do 280 osób. Uczyłem się pracy w szybko zmieniającym się środowisku." },
        { dateRange: "Mar 2019 - Mar 2020", role: "MineBest", desc: "R&D Marketing Specialist. Od środka poznałem jak działa „kopanie bitcoinów”." },
        { dateRange: "Lip 2018 - Sty 2019", role: "indaHash", desc: "Crypto Communication Specialist. Pierwsza rola w krypto. Fundamenty influencer marketingu i pracy w startupie." },
      ],
    },
    whatIBuildWithAI: {
      titleLine1: "Co Buduję",
      titleLine2: "Z AI",
      blocks: [
        { title: "Środowiska AI z pamięcią trwałą", desc: "Buduję wielowarstwowe systemy AI z plikami skill, protokołami sesji i pamięcią trwałą. Kontekst przechodzi między sesjami. Nic nie trzeba powtarzać, nic się nie gubi." },
        { title: "Produkcja contentu 80% szybsza", desc: "Buduję systemy produkcji contentu od briefu do publikacji, każdy krok zautomatyzowany, ludzkie review tam gdzie naprawdę trzeba. 80% szybciej niż ręcznie, często lepszej jakości." },
        { title: "Codzienny journaling z AI", desc: "Zbudowałem system 3 check-inów dziennie (plan rano, puls w południe, podsumowanie wieczorem), który wpada prosto do pamięci projektu. Decyzje się kumulują, a ja potrafię uzasadnić każdą z nich." },
        { title: "Customowe dashboardy HTML", desc: "Buduję dashboardy HTML pod konkretne projekty: Trello albo Asana skrojone pod jeden workflow, nie odwrotnie. Bez rozdmuchanych subskrypcji SaaS, bez funkcji których nie używasz." },
      ],
      stackTitle: "NARZĘDZIA, KTÓRYCH UŻYWAM",
      stack: [...fullStack],
      networkLabel: "SIEĆ AI",
    },
    testimonials: {
      eyebrow: "SOCIAL PROOF",
      heading: "Co mówią współpracownicy",
      items: [
        {
          name: "Iraklis Anastasiou",
          role: "Research Analyst & Writer @CoinTelegraph",
          quote: "Chris is a multifaceted individual. He is one of the few people I've met in a long time who has an amicable, infectiously positive, and ethical personality. His genuine character makes him easy to talk to and work with, and his deep knowledge of various subjects makes him a most valuable asset in any organization. He has a natural talent for learning anything and everything, consistently preparing highly thought-out and analytical work with meticulous and methodical quality. Pairing his battle-tested experience across a number of roles with his expertise in AI-driven automations and efficiencies, he is truly a one-man department. I highly recommend Chris for any senior management-level role and above.",
        },
        {
          name: "Paul Kruegel",
          role: "Advisor & Solo Founder",
          quote: "Chris has brought much-needed marketing intelligence and research to the Accelerator at Cointelegraph. He's a kind and smart listener who executes with confidence and a good sense of humor to keep presentations to clients or internal interesting. I am sure Chris will have a prosperous future, and he is a valuable asset to any marketing & intelligence team looking for a passionate data marketer with a kind and respectful demeanor.",
        },
        {
          name: "Michael Rhoden",
          role: "BD @TicTacc",
          quote: "Dynamically talented with both interpersonal and analytical skills, Chris played a crucial role in the Crypto Analytics and Communication team as a Communications Specialist. I had the pleasure of collaborating together with Chris on several projects simultaneously and always appreciated his go-getter and can-do attitude which he consistently brought to the team. I particularly appreciated Chris's seemingly effortless eye for detail and thoroughly enjoyed working with him. Chris would, without a doubt, be an asset to any team and could accomplish anything he sets his mind to.",
        },
      ],
      allRecommendationsCta: "Zobacz moje rekomendacje na LinkedIn →",
      allRecommendationsHref: "https://www.linkedin.com/in/krzysztofscibiorek/details/recommendations/",
    },
    whatsNext: {
      title: "Szukasz Growth Leada lub Strategy Leada?",
      body: "Otwarty na senior role zdalne.",
      ctaLinkedIn: "Napisz na LinkedIn",
      ctaLinkedInHref: "https://www.linkedin.com/in/krzysztofscibiorek",
      ctaDownloadCV: "Pobierz CV",
      ctaDownloadCVHref: "/cv/chris-scibiorek-cv-light.pdf",
      ctaDownloadCVDark: "wolisz dark?",
      ctaDownloadCVDarkHref: "/cv/chris-scibiorek-cv-dark.pdf",
    },
    floatingCta: {
      label: "Połącz",
      href: "https://www.linkedin.com/in/krzysztofscibiorek",
    },
  },

  legal: {
    cookieBanner: {
      message: "Używam cookies, żeby widzieć jak działa strona i ją ulepszać. Akceptuj pełną analitykę albo odrzuć. Ty decydujesz.",
      privacyLink: "Polityka prywatności",
      accept: "Akceptuję",
      reject: "Odrzucam",
    },
    footer: {
      privacy: "Prywatność",
    },
    privacy: {
      meta: {
        title: "Polityka prywatności · Chris Scibiorek",
        description: "Jak zbieram, wykorzystuję i chronię dane na chrisworkflows.com.",
      },
      title: "Polityka prywatności",
      lastUpdated: "Ostatnia aktualizacja: 2026-04-20",
      intro:
        "Ta strona wyjaśnia jakie dane zbieram kiedy odwiedzasz chrisworkflows.com, w jaki sposób je wykorzystuję i jakie masz prawa. Normalnym językiem, bez prawniczego bełkotu.",
      sections: [
        {
          heading: "1. Kim jestem (administrator danych)",
          body: "Chris Scibiorek (Krzysztof Ścibiorek), prowadzący jednoosobową działalność gospodarczą w Łodzi, Polska. NIP: 5272991875. Kontakt: hello@chrisworkflows.com.",
        },
        {
          heading: "2. Jakie dane zbieram",
          body: "Trzy kategorie: (a) Analityka: anonimowe odsłony stron, kliknięcia i nagrania sesji przez PostHog (hostowane w EU). Nagrania maskują wszystkie pola formularzy. (b) Formularz kontaktowy i newsletter: imię, email, opcjonalnie firma oraz treść pytania, które wysyłasz. (c) Discovery calls: email i imię podane w Cal.com przy rezerwacji rozmowy.",
        },
        {
          heading: "3. Dlaczego zbieram te dane",
          body: "Analityka: żeby widzieć które strony działają, a które nie (uzasadniony interes plus Twoja zgoda przez banner cookies). Formularz lub newsletter: żeby Ci odpowiedzieć i, jeśli się zapiszesz, wysyłać sporadyczne updates (zgoda: wysłałeś formularz). Discovery calls: żeby móc odbyć spotkanie (umowa).",
        },
        {
          heading: "4. Jak i gdzie dane są przechowywane",
          body: "PostHog: Frankfurt, EU (posthog.com/privacy). Web3Forms: przetwarza zgłoszenia formularza kontaktowego. Cal.com: przechowuje rezerwacje spotkań. iCloud i Gmail: otrzymuję powiadomienia na swoją skrzynkę. Żadne dane nie są sprzedawane, nigdy.",
        },
        {
          heading: "5. Jak długo przechowuję dane",
          body: "Analityka PostHog: do 7 lat (konfigurowalne). Zgłoszenia z formularza: trzymane w mailu bezterminowo, chyba że poprosisz o usunięcie. Newsletter: do momentu wypisania się.",
        },
        {
          heading: "6. Twoje prawa",
          body: "Masz prawo: uzyskać dostęp do swoich danych, sprostować je, usunąć, wnieść sprzeciw wobec przetwarzania lub wycofać zgodę w każdej chwili. Wystarczy napisać na hello@chrisworkflows.com. Odpowiem w ciągu 48h.",
        },
        {
          heading: "7. Cookies",
          body: "Tylko analytics cookies od PostHoga (first-party, brak third-party reklamowych). Pełna kontrola opt-in/opt-out przez banner na dole strony.",
        },
        {
          heading: "8. Zmiany w polityce",
          body: "Zaktualizuję datę 'Ostatnia aktualizacja' powyżej jeśli zmienię coś istotnego. Wpadnij tu od czasu do czasu.",
        },
      ],
      cookiePreferences: {
        heading: "Preferencje cookies",
        body: "Zmiana zdania? Zresetuj wybór, a banner cookies pojawi się ponownie i będziesz mógł zaakceptować lub odrzucić jeszcze raz.",
        button: "Zresetuj preferencje cookies",
        statusReset: "Preferencje zresetowane. Banner cookies jest z powrotem na dole strony.",
      },
    },
  },
};
